import React from 'react';
import SectionLayout from 'src/app/atoms/Layout/Section/SectionLayout';
import Stack from 'src/app/atoms/Layout/Stack/Stack';
import HeroTabbedFeatures from 'src/app/organisms/Homepage/HeroTabbedFeatures/HeroTabbedFeatures';
import HeroTextBlock from 'src/app/organisms/experiments/homepage_hero_headline_change/Homepage/HeroTextBlock/HeroTextBlock';

const HeroBanner = (): JSX.Element => {
  return (
    <SectionLayout
      maxWidth='width-3xl'
      padding={['spacing-7xl', 'spacing-none']}
      paddingSm={['spacing-4xl', 'spacing-none']}
    >
      <Stack
        direction='column'
        gap='spacing-7xl'
        gapSm='spacing-4xl'
      >
        <HeroTextBlock />
        <HeroTabbedFeatures />
      </Stack>
    </SectionLayout>
  );
};

export default HeroBanner;
